import DefaultError from 'next/error';
import PageTracker from '../PageTracker/PageTracker';

type TrackedErrorPage = {
  statusCode: number;
};

export const TrackedErrorPage = ({ statusCode }: TrackedErrorPage) => {
  const pageType = statusCode === 404 ? '404_ERROR_PAGE' : '500_ERROR_PAGE';
  return (
    <>
      <PageTracker
        pageData={{
          pageType,
        }}
      />
      <DefaultError statusCode={statusCode} withDarkMode={false} />
    </>
  );
};
